import { render, staticRenderFns } from "./UgcTools.vue?vue&type=template&id=ceb72524"
import script from "./UgcTools.vue?vue&type=script&lang=js"
export * from "./UgcTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports